export default "__VITE_ASSET__yn43kr3J__"